<template>
  <section id="advantage" class="section-advantage section-content">
    <div
      :class="[
        'section-title c-fff',
        { 'fade-in': isEnteringSectionAdvantage },
      ]"
    >
      <div class="section-title__title-wrapper">
        <h2 class="title-text fz-40-vw fz-mbl-32 fz-mbp-28 fw-700">
          What can you get from
        </h2>
        <img class="title-logo" :src="require('@/assets/images/logo.png')" />
      </div>

      <p class="section-title__subtitle fz-18 fz-mbp-15 fw-600 ta-center">
        GANGA7 is established in India back in 2008, stands out as a prominent
        betting platform.
      </p>
    </div>

    <div class="section-content">
      <img
        src="~@/assets/images/section-advantage/gold-sequins-background.png"
        alt="GANGA7 is one of the biggest global website, founded in
        UK since 2006."
        :class="['gold-dots', { 'show-gold-dots': isEnteringSectionAdvantage }]"
      />
      <img
        src="~@/assets/images/section-advantage/phone.png"
        :class="['phone', { 'show-phone': isEnteringSectionAdvantage }]"
        alt="GANGA7 is one of the biggest global website, founded in
        UK since 2006."
      />
      <img
        src="~@/assets/images/section-advantage/background-coins.png"
        :class="['coins', { 'show-coins': isEnteringSectionAdvantage }]"
        alt="GANGA7 is one of the biggest global website, founded in
        UK since 2006."
      />

      <div :class="['features', { 'fade-in': isEnteringSectionAdvantage }]">
        <div
          v-for="(feature, featureName) in featureData"
          :key="featureName"
          :class="['feature-content', featureName]"
        >
          <img :src="feature.icon" :alt="feature.description" class="icon" />
          <p class="fz-18-vw fz-mbl-14 c-fff ta-center lh-11">
            {{ feature.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isEnteringSectionAdvantage: {
      type: Boolean,
    },
  },

  data() {
    return {
      featureData: {
        "experience-support": {
          icon: require("@/assets/images/section-advantage/experience-support.png"),
          description: "15 Years Experience Support",
        },
        "safe-finance-system": {
          icon: require("@/assets/images/section-advantage/safe-finance-system.png"),
          description: "Safe Finance System",
        },
        "quick-payouts": {
          icon: require("@/assets/images/section-advantage/quick-payouts.png"),
          description: "Quick Payouts",
        },
        "tons-of-sports-games": {
          icon: require("@/assets/images/section-advantage/tons-of-sports-games.png"),
          description: "Tons of Sports & Games",
        },
        "lucky-spin": {
          icon: require("@/assets/images/section-advantage/lucky-spin.png"),
          description: "Lucky Spin",
        },
        "free-to-apply": {
          icon: require("@/assets/images/section-advantage/free-to-apply.png"),
          description: "Free to Apply",
        },
      },
    };
  },
};
</script>

<style lang="scss">
.section-advantage {
  @include mq(mbp) {
    height: auto;
    min-height: inherit;
    max-height: inherit;
  }

  height: auto;
  min-height: 750px;
  max-height: 850px;
  padding-top: 60px;

  .section-title {
    transition: all 0.65s;

    opacity: 0;

    &.fade-in {
      opacity: 1;
    }

    &__title-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;

      .title-logo {
        height: 40px;
        margin: 0 10px;
      }
    }

    &__subtitle {
      @include mq(mbp) {
        padding: 0 5%;
      }

      margin-top: 26px;
    }
  }

  .section-content {
    @include mq(mbl) {
      width: 100%;
    }
    @include mq(mbp) {
      height: auto;
      padding-bottom: 30px;
      flex-direction: column;
    }

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    width: 80%;
    max-width: 1000px;
    height: 100%;
    margin: 0 auto;
    padding-bottom: 30px;

    overflow: hidden;

    .gold-dots {
      @include mq(mbl) {
        width: 120%;
      }
      @include mq(mbp) {
        width: 180%;
      }

      position: relative;

      width: 100%;
      height: auto;

      transform: translateY(100px) scale(0.6, 0.6);
      transition: all 0.8s 0.8s;

      opacity: 0;

      &.show-gold-dots {
        transform: translate(14px, 0);

        opacity: 1;
      }
    }

    .phone {
      @include mq(mbl) {
        width: 40%;
      }
      @include mq(mbp) {
        top: 0;
        width: 60%;
      }

      position: absolute;

      width: 31%;
      max-width: 450px;
      height: auto;

      transform: translateY(100px);
      transition: all 0.8s 1.2s;

      opacity: 0;

      &.show-phone {
        transform: translateY(80px) scale(1.1);

        opacity: 1;
      }
    }

    .coins {
      position: absolute;
      top: 0;
      left: 0;

      width: 100%;

      transition: all 0.8s 1.5s;

      opacity: 0;

      &.show-coins {
        opacity: 1;
      }
    }

    .features {
      @include mq(mbp) {
        flex-wrap: wrap;
        justify-content: center;

        bottom: 0;

        position: relative;
      }

      display: flex;
      justify-content: space-between;

      position: absolute;
      bottom: 0;

      width: 100%;

      transform: translateY(100px);
      transition: all 0.8s 1.8s;

      opacity: 0;

      &.fade-in {
        transform: translateY(0);

        opacity: 1;
      }

      .feature-content {
        @include mq(mbp) {
          width: 33%;
          margin-bottom: 10px;
        }

        display: flex;
        flex-direction: column;
        align-items: center;

        width: 165px;

        .icon {
          @include mq(mbp) {
            width: 30px;
            height: 30px;
            margin-bottom: 10px;
          }

          width: 48px;
          height: 48px;
          margin-bottom: 20px;

          object-fit: contain;
          object-position: 50% 50%;
        }
      }
    }
  }
}
</style>
